// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f6f9;
  font-family: "URW DIN Cond";
}

.card_upload {
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  width: 600px;
  padding: 40px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.card_upload h3 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
  font-family: "URW Din Condensed", "URW Din", urw-din-condensed, Cairo;
}

.file {
  width: 100%;
  margin-bottom: 20px;
}

.file-label {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 25px;
  background-color: #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid #e0e0e0;
  transition: background-color 0.3s ease;
}

.file-label:hover {
  background-color: #d9d9d9;
}

.file-input {
  display: none;
}

.file-cta {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #555;
  margin-left: 10px;
}

.file-name {
  display: block;
  margin-top: 10px;
  color: #555;
  font-size: 14px;
}

.btn {
  background-color: #005af0;
  color: #ffffff;
  padding: 12px 25px;
  border: none;
  outline: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.btn:hover {
  background-color: #ffffff;
  color: #005af0;
  border: 1px solid #005af0;
  transform: scale(1.05);
}

.error,
.success {
  margin-top: 10px;
  font-size: 14px;
}

.error {
  color: red;
}

.success {
  color: green;
}

.Toastify__toast-container {
  font-family: "Arial", sans-serif;
  padding: 10px;
}

.Toastify__toast {
  padding: 15px;
  border-radius: 5px;
}

.Toastify__toast--success {
  background-color: #4caf50;
  color: white;
}

.Toastify__toast--error {
  background-color: #f44336;
  color: white;
}

.progress-container {
  margin: 10px auto;
  width: 500px;
  text-align: center;
}

.progress {
  background: rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25),
    0 1px rgba(255, 255, 255, 0.08);
}

.progress-bar {
  height: 18px;
  background-color: #ee303c;
  border-radius: 4px;
  transition: width 0.4s linear;
}

.progress-striped .progress-bar {
  background-color: #2c41f7;
  background-image: linear-gradient(
    45deg,
    #005af0 25%,
    transparent 25%,
    transparent 50%,
    #005af0 50%,
    #005af0 75%,
    transparent 75%,
    transparent
  );
  animation: progressAnimationStrike 1.8s linear infinite;
}

@keyframes progressAnimationStrike {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 40px 0;
  }
}

.card_upload p {
  margin-top: 5px;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/document.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB;mCACiC;AACnC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB;;;;;;;;;GASC;EACD,uDAAuD;AACzD;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,eAAe;AACjB","sourcesContent":[".container {\r\n  height: 100vh;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: #f4f6f9;\r\n  font-family: \"URW DIN Cond\";\r\n}\r\n\r\n.card_upload {\r\n  border-radius: 12px;\r\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);\r\n  width: 600px;\r\n  padding: 40px;\r\n  background-color: #ffffff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;\r\n}\r\n\r\n.card_upload h3 {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 20px;\r\n  letter-spacing: 0.5px;\r\n  font-family: \"URW Din Condensed\", \"URW Din\", urw-din-condensed, Cairo;\r\n}\r\n\r\n.file {\r\n  width: 100%;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.file-label {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 12px 25px;\r\n  background-color: #f0f0f0;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  border: 2px solid #e0e0e0;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.file-label:hover {\r\n  background-color: #d9d9d9;\r\n}\r\n\r\n.file-input {\r\n  display: none;\r\n}\r\n\r\n.file-cta {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 16px;\r\n  color: #555;\r\n  margin-left: 10px;\r\n}\r\n\r\n.file-name {\r\n  display: block;\r\n  margin-top: 10px;\r\n  color: #555;\r\n  font-size: 14px;\r\n}\r\n\r\n.btn {\r\n  background-color: #005af0;\r\n  color: #ffffff;\r\n  padding: 12px 25px;\r\n  border: none;\r\n  outline: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.btn:hover {\r\n  background-color: #ffffff;\r\n  color: #005af0;\r\n  border: 1px solid #005af0;\r\n  transform: scale(1.05);\r\n}\r\n\r\n.error,\r\n.success {\r\n  margin-top: 10px;\r\n  font-size: 14px;\r\n}\r\n\r\n.error {\r\n  color: red;\r\n}\r\n\r\n.success {\r\n  color: green;\r\n}\r\n\r\n.Toastify__toast-container {\r\n  font-family: \"Arial\", sans-serif;\r\n  padding: 10px;\r\n}\r\n\r\n.Toastify__toast {\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.Toastify__toast--success {\r\n  background-color: #4caf50;\r\n  color: white;\r\n}\r\n\r\n.Toastify__toast--error {\r\n  background-color: #f44336;\r\n  color: white;\r\n}\r\n\r\n.progress-container {\r\n  margin: 10px auto;\r\n  width: 500px;\r\n  text-align: center;\r\n}\r\n\r\n.progress {\r\n  background: rgba(0, 0, 0, 0.25);\r\n  border-radius: 6px;\r\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25),\r\n    0 1px rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.progress-bar {\r\n  height: 18px;\r\n  background-color: #ee303c;\r\n  border-radius: 4px;\r\n  transition: width 0.4s linear;\r\n}\r\n\r\n.progress-striped .progress-bar {\r\n  background-color: #2c41f7;\r\n  background-image: linear-gradient(\r\n    45deg,\r\n    #005af0 25%,\r\n    transparent 25%,\r\n    transparent 50%,\r\n    #005af0 50%,\r\n    #005af0 75%,\r\n    transparent 75%,\r\n    transparent\r\n  );\r\n  animation: progressAnimationStrike 1.8s linear infinite;\r\n}\r\n\r\n@keyframes progressAnimationStrike {\r\n  from {\r\n    background-position: 0 0;\r\n  }\r\n  to {\r\n    background-position: 40px 0;\r\n  }\r\n}\r\n\r\n.card_upload p {\r\n  margin-top: 5px;\r\n  font-size: 14px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
